export default "__VITE_ASSET__iglFs15G__"